import React from 'react'

import { COMMON_ERROR } from 'utils/ErrorMessages'
import { getCombinedId } from 'utils/helpers'
import { getActiveIntegrationLabel } from 'utils/integrations'
import { getPlanName } from 'utils/plans'
import { getRoleNameById, OWNER_ROLE } from 'utils/roles'
import { URL_CONST } from 'utils/urlConsts'

import * as Sentry from '@sentry/browser'

export default class App extends React.Component {
  state = {
    hasError: false,
  }

  componentDidMount() {
    const { isDataLoaded } = this.props

    if (isDataLoaded) {
      this.initializeServices(this.props)
    } else {
      this.props.fetchAppData()
    }

    if (window.innerWidth <= 750 && window.location.pathname.indexOf('attackdetails') === -1) {
      this.props.history.push(URL_CONST.incidents.self)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.isDataLoaded && nextProps.isDataLoaded) {
      this.initializeServices(nextProps)
    }
  }

  initializeServices = (relevantProps) => {
    this.props.incidentsCountPolling()

    const combinedUserId = getCombinedId(
      relevantProps.environment,
      relevantProps.region,
      relevantProps.user.id
    )

    const combinedCompanyId = getCombinedId(
      relevantProps.environment,
      relevantProps.region,
      relevantProps.selfCompanyId
    )

    // Google Tag Manager
    // GTM dataLayer https://developers.google.com/tag-manager/devguide
    if (typeof window.dataLayer?.push === 'function') {
      window.dataLayer.push({
        userId: combinedUserId,
        companyId: combinedCompanyId,
      })
    }

    // to cover MSP case use pendoMSPSupportMiddleware
    if (typeof window.pendo?.initialize === 'function') {
      window.IRONSCALES.pendoData = {
        visitor: {
          id: combinedUserId,
          email: relevantProps.user.email,
          full_name: relevantProps.user.fullName,
          role: relevantProps.isOwner ? OWNER_ROLE.name : getRoleNameById(relevantProps.user.role),
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'None',
          internal: !!relevantProps.isMaster,
          is_partner: relevantProps.isPartner,
          static_demo: relevantProps.isStaticSalesDemo,
        },

        account: {
          id: combinedCompanyId,
          company_name: relevantProps.selfCompanyName,
          integration: getActiveIntegrationLabel(relevantProps.selfIntegrations),
          plan: getPlanName(relevantProps.selfLicenses?.plan),
          is_partner: relevantProps.isPartner,
          brand_name: relevantProps.brandName,
          partner_name: relevantProps.partnerName,
          mailbox_limit: relevantProps.mailboxLimit,
          mailbox_enabled: relevantProps.mailboxEnabled,
          static_demo: relevantProps.isStaticSalesDemo,
        },
      }

      window.pendo.initialize(window.IRONSCALES.pendoData)
    }
  }

  Logo = () => (
    <img onLoad={(e) => e.target.classList.add('loaded')} src="/static/webapp/img/main-logo.svg" />
  )

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
    if (window.SENTRY_INITIALIZED && NODE_ENV !== 'development') {
      // eslint-disable-line
      Sentry.captureException(error, {
        user: {
          email: this.props.user.email,
        },
        extra: info,
        tags: {
          source: 'App.componentDidCatch',

          companyId: this.props.selfCompanyId,
        },
      })
    } else {
      console.error('App.componentDidCatch', error, info)
    }
  }

  render() {
    const { error, isDataLoaded } = this.props

    if (error || this.state.hasError) {
      return (
        <div className="hide-preloader app-preloader">
          <div className="app-preloader-center-outer">
            <div className="app-preloader-center-middle">
              <this.Logo />
              <div className="app-preloader-error">{error?.detail || COMMON_ERROR}</div>
            </div>
          </div>
        </div>
      )
    }

    if (isDataLoaded) {
      return <div className="hide-preloader-animated app-container">{this.props.children}</div>
    }

    return ''
  }
}
